import { Component, OnInit ,ViewChild} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { NativeService} from '../../../../service/native.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { DatePipe } from '@angular/common';
declare var app;
@Component({
  selector: 'app-a2-gift-inventory',
  templateUrl: './a2-gift-inventory.component.html',
  styleUrls: ['./a2-gift-inventory.component.scss']
})
export class A2GiftInventoryComponent extends GridBaseCase {
  CustomInterfaceOptions: any = {
    header: '产品列表',
    // subHeader: 'Select your toppings',
    // message: '$1.00 per topping',
    // translucent: true
  };
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  isSelectCahage:boolean = false;//是否多次点击
  dataArrayList: Array<any> = [];
  productArrayList:Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName:string = null;
  isAddProduct:boolean = true;//是否可以添加产品
  isSubmitData:boolean = true;//是否可以提交数据
  isAndroid4:boolean = false;//安卓4以下
  max:any;//最大日期
  isreturnGoods:boolean  =false;//是否退货页面
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native:NativeService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if(this.pageName=="ReturnGoods"){//消费者退货
      this.isreturnGoods=true;
    }
    // this.getProductList();
    this.baseService.FixedSubmitBtn.configName = "GiftInventory";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "全部提交";
    this.baseService.FixedSubmitBtn.type = 1;

    this.isAndroid4 = this.com.Isandroidversion;
    this.max=this.com.TenTime;
  }
  EventLink(event,item){
    // console.log(item);
    localStorage.setItem("information",JSON.stringify(item));
    this.com.setHistoryUrl();
    // this.router.navigate([event.url+item.id.value]);
    this.com.Go(event.url+item.id.value);
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber){
    let that = this;
  
    console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    console.log(that.element.selectItemList.gridViewConfigName,"接口名称");
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    // if(PageName == 'RepurchaseReminder'){
    //   typeObj = {"Type":1};
    // }else if(PageName == 'TransitionReminder'){
    //   typeObj = {"Type":2};
    // }else if(PageName == 'AwakenReminder'){
    //   typeObj = {"Type":3};
    // }else if(PageName == 'BirthdayReminder'){
    //   typeObj = {"Type":4};
    // }else if(PageName == 'NewcustomersReminder'){
    //   typeObj = {"Type":5};
    // }
    // body.RequestBody = JSON.stringify(typeObj);
    // body.RequestBody["a_id"]="12121";
    that.http.post(app.DEFAULTURL, body).then(data => {
       console.log(data,"数据");
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.dataArrayList.push(objfield);
          
          // that.dataArrayList.forEach(data=>{
          //   if(data.orderCreateDate.value){
          //     let datepie: DatePipe = new DatePipe("en-US");
          //     data.orderCreateDate.value =  datepie.transform(data.orderCreateDate.value.replace(/-/g,"/"), 'yyyy-MM-dd');
          //   }
          // });
          //console.log(that.dataArrayList);
        });
        // console.log(that.dataArrayList,"dataArrayList");
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
 }
  /**
   * 添加产品
   */
  getProductList(){
    let that = this;
    that.productArrayList=[];
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBProductInformationXML";
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
       that.productArrayList=data.Status.Datas;
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      console.log(error);
    });
  }
  /**
   * 产品列表
   * @param event 
   */
  changeSelect(event){

    const that =this;
    if(that.isAddProduct){
      that.isAddProduct = false;
      setTimeout(()=>{
        that.isAddProduct = true;
      },400);
    }else{
      return;
    }
    // console.log(event.detail.value);
    event.detail.value.forEach(detail=>{
      that.productArrayList.forEach(prod=>{
        if(prod.a_ID==detail){
          let details = {};
          details["product_id"]={"value":null,"text":""};
          details["id"]={"value":prod.a_ID,"text":""};
          details["groupName"]={"value":prod.a_ProductName,"text":""};
          details["stock"]={"value":null,"text":""};
          details["jdName"]={"value":prod.j_Name,"text":""};
          details["orderCreateDate"]={"value":null,"text":""};
          that.dataArrayList.push(details);
        }
      });
    });
  }
  /**
   * 分销人
   * @param item 
   */
  onInput(item,event){
    let that = this;
    console.log(10086);
   setTimeout(()=>{
     if(event.target.value){
      let numvalue:any= this.com.GetNumber(event.target.value);
       if(numvalue){
         item.stock.value = numvalue;
         event.target.value = numvalue;
        }else{
         item.stock.value = 0;
         event.target.value=0;
       }
     }else{
      event.target.value=null;
      item.stock.value = 0;
     }
    //  if(item.product_id.value){
    //    if(!item.stock.value){
    //     //  that.msg.Alert("盘库数量不能小于零，默认为1");
    //     item.stock.value=0;
    //     event.target.value=0;
    //    }
    //  }
   },400);
  }
  Eventdatetime(event,item){
    item.orderCreateDate.value=event.detail.value;
    // console.log(item);
    // console.log(event);
  }
  /**
   * 提交数据
   */
  EventSubmitClick(){
    const that =this;
    // console.log(that.isSubmitData,"that.isSubmitData");
    // if(that.isSubmitData){
    //   that.isSubmitData = false;
    // }else{
    //   return;
    // }
    // let inventoryObj = that.com.InventoryDatelimit();
    // if(!inventoryObj["isSubmit"]){
    //   that.msg.Alert("盘库日期仅限当月"+inventoryObj["begin"]+"号至"+inventoryObj["end"]+"号");
    //   that.baseService.FixedSubmitBtn.isSubmitData = true;
    //   return;
    // }
    console.log("赠品");
    let arrayDataList:Array<any> = new Array<any>();
  
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "TBGiftStockXML";
  body.OpType = "add";
  body.ConfigType = "form";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 0;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  console.log("置顶最新数据指定最新数据");
  console.log(that.dataArrayList);
  that.dataArrayList.forEach(items=>{
    let fk_tbgiftstock_id:any=items.fk_tbgiftstock_id.value;//赠品ID
    if(items["stock"].value || fk_tbgiftstock_id){//产品数量
      if(fk_tbgiftstock_id){
        body.OpType = "edite";
      }
      let c={};
      // c["ID"]=items["id"].value;
      if(that.com.GetStorageKey("tbstore")){
        c["a_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore")["ID"];
      }
      c["a_FK_TBGift_ID"]=items["id"].value;
      c["a_FK_TBGiftStock_ID"]=fk_tbgiftstock_id;
      c["a_Stock"]=items["stock"].value;
      c["a_StockNum"]=items["stocknum"].value;
      c["a_OldStock"]=items["oldstock"].value;
      arrayDataList.push(c);
    }
  });
  if(arrayDataList.length<=0){
    that.baseService.FixedSubmitBtn.isSubmitData = true;
    that.msg.Alert("必须填写库存数量");
    return;
  }
  body.RequestBody = JSON.stringify(arrayDataList);
  //  return;
   that.msg.Confirm("确定提交吗?","取消","确定","",false).then(res=>{
     if(res){
      that.http.post(app.DEFAULTURL, body).then(data => {
        that.baseService.FixedSubmitBtn.isSubmitData = true;
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          console.log(data);
          that.dataArrayList= new Array<any>();
          that.com.goBack();
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.baseService.FixedSubmitBtn.isSubmitData = true;
        console.log(error);
      });
     }
   })
  }

}
